(function () {
  'use strict';

  let stores = [];
  let storesLoaded = false;
  let loadPromise = null;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function loadStores() {
    if (storesLoaded) {
      return Promise.resolve(stores);
    }

    if (loadPromise) {
      return loadPromise;
    }

    const dataUrl =
      window.LoopieStoreSearch &&
      window.LoopieStoreSearch.storesDataUrl;

    if (!dataUrl) {
      console.error(
        'Loopie Store Search: storesDataUrl not found.'
      );

      return Promise.resolve([]);
    }

    loadPromise = fetch(dataUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Failed to load stores-data.json'
          );
        }

        return response.json();
      })
      .then(function (data) {

        stores = [];

        Object.keys(data || {}).forEach(function (city) {

          const cityStores = Array.isArray(data[city])
            ? data[city]
            : [];

          cityStores.forEach(function (store) {

            stores.push({
              name: store.name || 'Loopie Store',
              address: store.address || '',
              phone: store.phone || '',
              hours: store.hours || '',
              directions: store.directions || '',
              city: city
            });

          });

        });

        storesLoaded = true;

        return stores;
      })
      .catch(function (error) {

        console.error(
          'Loopie Store Search:',
          error
        );

        stores = [];

        return [];
      });

    return loadPromise;
  }

  function findMatchingStores(query) {

    const normalizedQuery = normalize(query);

    if (
      !normalizedQuery ||
      normalizedQuery.length < 2
    ) {
      return [];
    }

    const queryWords =
      normalizedQuery.split(' ');

    return stores
      .filter(function (store) {

        const searchableText = normalize([
          store.city,
          store.name,
          store.address
        ].join(' '));

        return queryWords.every(function (word) {
          return searchableText.includes(word);
        });

      })
      .slice(0, 5);
  }

  function escapeHTML(value) {

    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }

  function createStoreHTML(store) {

    const name =
      escapeHTML(store.name);

    const address =
      escapeHTML(store.address);

    const city =
      escapeHTML(
        store.city.replace(/-/g, ' ')
      );

    const directions =
      store.directions
        ? escapeHTML(store.directions)
        : '';

    return `
      <div class="predictive-store-item">

        <div
          class="predictive-store-icon"
          aria-hidden="true">

          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18">

            <path
              d="M12 21s7-6.2 7-12A7 7 0 0 0 5 9c0 5.8 7 12 7 12Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
            />

            <circle
              cx="12"
              cy="9"
              r="2.3"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
            />

          </svg>

        </div>

        <div class="predictive-store-content">

          <div class="predictive-store-name">
            ${name}
          </div>

          <div class="predictive-store-city">
            ${city}
          </div>

          <div class="predictive-store-address">
            ${address}
          </div>

          <div class="predictive-store-actions">

            ${
              directions
                ? `
                  <a
                    href="${directions}"
                    class="predictive-store-link"
                    target="_blank"
                    rel="noopener noreferrer">

                    Get Directions

                  </a>
                `
                : ''
            }

          </div>

        </div>

      </div>
    `;
  }

  function renderStores(query) {

    const container =
      document.querySelector(
        '#predictive-store-search'
      );

    if (!container) {
      return;
    }

    const matchingStores =
      findMatchingStores(query);

    if (!matchingStores.length) {

      container.innerHTML = '';
      container.hidden = true;

      return;
    }

    container.innerHTML = `

      <div class="predictive-store-heading">

        <span class="predictive-store-heading-title">
          STORES
        </span>

        <div class="predictive-store-heading-right">

          <span>
            ${matchingStores.length}
            ${matchingStores.length === 1
              ? 'store'
              : 'stores'}
          </span>

          <button
            type="button"
            class="predictive-store-close"
            aria-label="Hide store results"
            title="Hide store results">
            ×
          </button>

        </div>

      </div>

      <div class="predictive-store-list">

        ${matchingStores
          .map(createStoreHTML)
          .join('')}

      </div>

    `;

    container.hidden = false;
  }

  function hideStores() {

    const container =
      document.querySelector(
        '#predictive-store-search'
      );

    if (!container) {
      return;
    }

    container.innerHTML = '';
    container.hidden = true;
  }

  function initStoreCloseButton() {

    const container =
      document.querySelector(
        '#predictive-store-search'
      );

    if (!container) {
      return;
    }

    if (
      container.dataset.closeInitialized === 'true'
    ) {
      return;
    }

    container.dataset.closeInitialized = 'true';

    container.addEventListener(
      'click',
      function (event) {

        const closeButton =
          event.target.closest(
            '.predictive-store-close'
          );

        if (!closeButton) {
          return;
        }

        hideStores();

      }
    );
  }

  function getSearchInput() {

    return document.querySelector(
      'input[name="q"], input[type="search"], .search__input'
    );

  }

  function handleSearchInput(event) {

    const query =
      event.target.value || '';

    if (
      query.trim().length < 2
    ) {

      hideStores();

      return;
    }

    loadStores().then(function () {

      renderStores(query);

    });

  }

  function init() {

    const input =
      getSearchInput();

    if (!input) {
      return;
    }

    initStoreCloseButton();

    if (
      input.dataset.storeSearchInitialized === 'true'
    ) {
      return;
    }

    input.dataset.storeSearchInitialized =
      'true';

    input.addEventListener(
      'input',
      handleSearchInput
    );

    input.addEventListener(
      'search',
      handleSearchInput
    );

  }

  document.addEventListener(
    'DOMContentLoaded',
    init
  );

  document.addEventListener(
    'shopify:section:load',
    init
  );

  const observer =
    new MutationObserver(function () {
      init();
    });

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();